'use client';

import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';

import { AuthPopupKeys, AuthResponseProps } from './auth.types';

export const AuthResponse = (props: WithLang<AuthResponseProps>) => {
    const { message, title } = props.responseContent;

    const { t } = useTranslation(props.lang, 'auth');
    // const router = useRouter();
    // const pathname = usePathname();

    const onRedirect = (key: AuthPopupKeys) => {
        props.onClick && props.onClick();
        props.onRedirect(key);
    };

    const onClose = () => {
        props.onClose();
    };

    return (
        <>
            {props.isSuccess ? (
                <>
                    <p className="text-2xl">{title}</p>
                    <div className="mx-auto h-52 w-full bg-success bg-contain bg-center bg-no-repeat py-5 md:w-2/3" />
                    <p className="text-center text-base">{message}</p>
                    <button onClick={onClose} className="btn-accent">
                        {t('buttons.close')}
                    </button>
                </>
            ) : (
                <>
                    <p className="text-2xl">{title}</p>
                    <div className="flex flex-col border-b border-opacity-30 pb-8">
                        <div className="mx-auto h-52 w-full bg-fault bg-contain bg-center bg-no-repeat py-5 md:w-2/3" />
                        <p className="mt-3 text-center text-base">{message}</p>
                    </div>
                    <div className="mx-auto flex w-full flex-col items-stretch justify-center gap-x-2 gap-y-3 xs:w-5/6">
                        {/*<p className="s:text-right flex-1 text-center text-sm">{t('common.noAccount')}</p>*/}
                        <button
                            onClick={() => onRedirect(AuthPopupKeys.LOGIN)}
                            className="btn-primary flex-1 border-accent text-sm md:border-solid"
                        >
                            {t('buttons.loginShort')}
                        </button>
                        <button onClick={() => onRedirect(AuthPopupKeys.REFRESH)}>Восстановить пароль</button>
                    </div>
                </>
            )}
        </>
    );
};
